// extracted by mini-css-extract-plugin
export default {"radio-container":"radio-group_radio-container__QRInw","radio":"radio-group_radio__31rHt","option":"radio-group_option__Atcpo"};